import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Título',
      placeholder: 'Introduce el título de la notificación',
    },
    body: {
      label: 'Cuerpo del mensaje',
      placeholder: 'Introduce tu mensaje',
    },
    promo_code: {
      label: 'Código promocional',
      placeholder: 'Seleccionar código promocional',
    },
    offers: {
      label: 'Ofertas',
      placeholder: 'Seleccionar oferta',
    },
    campaign_type: {
      label: 'Tipo de campaña',
      placeholder: 'Seleccionar tipo de campaña',
    },
    tone: {
      label: 'Tono de voz',
      placeholder: 'Seleccionar un tono',
    },
  },
  attachment: {
    heading: '¿Qué debe promocionar esta campaña?',
    offer: {
      title: 'Oferta',
      description: 'Elige entre tus ofertas activas.',
    },
    promo_code: {
      title: 'Código promocional',
      description: 'Elige entre tus códigos promo activos.',
    },
  },
  buttons: {
    generate: 'Generar',
    improve: 'Mejorar con IA',
    undo: 'Deshacer ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Amigable 🙂',
    [ToneTypes.Elegant]: 'Elegante ✨',
    [ToneTypes.Playful]: 'Juguetón 🎉',
    [ToneTypes.Professional]: 'Profesional 👨‍💼',
    [ToneTypes.Informative]: 'Informativo 📊',
    [ToneTypes.Persuasive]: 'Persuasivo 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promocional 🚀',
    [CampaignTypes.Informational]: 'Informacional ℹ️',
  },
  no_promo_codes: {
    title: 'Sin códigos promo válidos',
    description: 'Crea un nuevo código promo.',
    create_promo_code: 'Crear código promo',
  },
  no_offers: {
    title: 'Sin ofertas activas',
    description: 'Crea una nueva oferta.',
    create_offer: 'Crear oferta',
  },
  feedback: {
    success: 'Generado con éxito',
    error: 'Error al generar',
  },
};
